import React, { useCallback, useRef } from 'react';
import { useKeyboardShortcuts } from '@fiverr-private/hooks';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { useModalContext } from '../ModalContext';
import { ModalCancelBtnProps } from '../types';

const ModalCancelBtn = ({
  onClick,
  children = <I18n k="overlay.modal.cancelButton.cta" />,
  size = 'md',
}: ModalCancelBtnProps) => {
  const { close } = useModalContext();
  const ref = useRef(null);
  const getTarget = useCallback(() => ref.current, [ref]);

  const onTrigger = (e) => {
    onClick?.(e);
    close?.();
  };

  useKeyboardShortcuts(
    [
      {
        trigger: 'enter',
        handler: onTrigger,
      },
      {
        trigger: 'space',
        handler: onTrigger,
      },
    ],
    getTarget
  );

  return (
    <Button ref={ref} size={size} variant="ghost" onClick={onTrigger}>
      {children}
    </Button>
  );
};

ModalCancelBtn.displayName = 'ModalCancelBtn';

export default ModalCancelBtn;
